export enum Status {
  NOT_STARTED_YET = 'NOT_STARTED_YET',
  DONE = 'DONE',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING_CUSTOMER = 'PENDING_CUSTOMER',
  UNSUCCESSFUL = 'UNSUCCESSFUL',
  SKIPPED = 'SKIPPED',
}
